import { Component, OnInit } from '@angular/core';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { MainGridService } from 'src/app/components/maingrid/main-grid.service';
import { AimsCommonTableFilterType, AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions, TableRowUpdate } from '@aims/common-components';
import { FormControl, Validators } from '@angular/forms';
import { AllStatesOrTerritories } from 'src/models';
import { States } from '../config-common';

@Component({
  selector: 'app-states',
  templateUrl: './states.component.html',
  styleUrls: ['./states.component.css'],
  providers: [MainGridService]
})
export class StatesComponent implements OnInit {

    constructor(private transferHttp: TransferHttpService,
    public permissionsService: PermissionsService,
    public mainGridService: MainGridService<any>) { }

  states = this.mainGridService.getAll(
    'Config/GetStatesForEditing',
    'Config/SaveState'); 

  initialTableElement;
  canCreate = this.permissionsService.canCreate(this.permissionsService.ComponentID.Config);
  canUpdate = this.permissionsService.canCreate(this.permissionsService.ComponentID.Config);

  tablePermissions: AimsCommonTablePermissions = {
    create: this.canCreate,
    update: this.canUpdate,
    delete: false,
    export: false
  }
  header: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'stateOrTerritory', label: 'State/Territory Name', type: AimsCommonTableHeaderType.STRING, validatorOrOpts: Validators.compose([Validators.required, Validators.maxLength(150)])},
    { key: 'abbreviation', label: 'Abbreviation', type:  AimsCommonTableHeaderType.STRING, validatorOrOpts: [Validators.maxLength(10)] },
    { key: 'postalCode', label: 'Postal Code', type:  AimsCommonTableHeaderType.STRING, validatorOrOpts: Validators.compose([Validators.required, Validators.maxLength(2)])  },
    { key: 'isDefault', label: 'Is Default for Employees', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN }

  ]
  handleRowUpdate(update: TableRowUpdate){
    var row = update.newRow as AllStatesOrTerritories;
    this.mainGridService.update(row, update.index).subscribe();
  }
  handleRowAdd(update: TableRowUpdate){
    var row = update.newRow as AllStatesOrTerritories;
    this.mainGridService.add(row).subscribe();
  }
  ngOnInit(): void {
    this.initialTableElement = new States();
  }

}
